var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineDiscountPercentCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1171_5012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5308 30.5357L30.6022 14.4643M1.60938 35.3572C1.60937 36.2085 1.94714 37.0251 2.54854 37.6277C3.14995 38.2303 3.96586 38.5697 4.81723 38.5714H40.1872C41.0386 38.5697 41.8545 38.2303 42.4559 37.6277C43.0573 37.0251 43.3951 36.2085 43.3951 35.3572V28.8193C42.0072 28.443 40.7819 27.6202 39.9082 26.4781C39.0346 25.336 38.5612 23.938 38.5612 22.5C38.5612 21.0621 39.0346 19.6641 39.9082 18.522C40.7819 17.3798 42.0072 16.5571 43.3951 16.1807V9.64287C43.3951 8.79151 43.0573 7.97491 42.4559 7.3723C41.8545 6.76969 41.0386 6.43029 40.1872 6.42859H4.81723C3.96586 6.43029 3.14995 6.76969 2.54854 7.3723C1.94714 7.97491 1.60937 8.79151 1.60938 9.64287V16.1679C3.00829 16.5358 4.24599 17.3566 5.12921 18.5022C6.01242 19.6477 6.49143 21.0535 6.49143 22.5C6.49143 23.9465 6.01242 25.3523 5.12921 26.4978C4.24599 27.6434 3.00829 28.4642 1.60938 28.8322V35.3572Z",
    stroke: "white",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1384 17.6786C16.5646 17.6786 16.9734 17.5093 17.2748 17.2079C17.5762 16.9065 17.7455 16.4977 17.7455 16.0715C17.7455 15.6453 17.5762 15.2365 17.2748 14.9351C16.9734 14.6337 16.5646 14.4644 16.1384 14.4644C15.7122 14.4644 15.3034 14.6337 15.002 14.9351C14.7006 15.2365 14.5312 15.6453 14.5312 16.0715C14.5312 16.4977 14.7006 16.9065 15.002 17.2079C15.3034 17.5093 15.7122 17.6786 16.1384 17.6786ZM28.9955 30.5358C29.4218 30.5358 29.8306 30.3665 30.132 30.0651C30.4334 29.7637 30.6027 29.3549 30.6027 28.9286C30.6027 28.5024 30.4334 28.0936 30.132 27.7922C29.8306 27.4908 29.4218 27.3215 28.9955 27.3215C28.5693 27.3215 28.1605 27.4908 27.8591 27.7922C27.5577 28.0936 27.3884 28.5024 27.3884 28.9286C27.3884 29.3549 27.5577 29.7637 27.8591 30.0651C28.1605 30.3665 28.5693 30.5358 28.9955 30.5358Z",
    stroke: "white",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_5012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineDiscountPercentCoupon);
export default __webpack_public_path__ + "static/media/streamline_discount-percent-coupon.28d203eea73a75680d51d9d4a1630cb9.svg";
export { ForwardRef as ReactComponent };